import { render } from "./NewsComponent.vue?vue&type=template&id=127d2633&scoped=true"
import script from "./NewsComponent.vue?vue&type=script&lang=js"
export * from "./NewsComponent.vue?vue&type=script&lang=js"

import "./NewsComponent.vue?vue&type=style&index=0&id=127d2633&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d2633"]])

export default __exports__